module.exports = __webpack_public_path__ + "static/md-logo-web-inline-9144249c551e5278d5f4dc5a7209d9eb.png";